module.exports = __webpack_public_path__ + "static/media/uisce.f9b5c35c.png";